import Common from "../Common";

const Icon = class extends Common {
	browse = (type = 'svg'): CustomResponse<Icon[]> =>
		this.get(`/icons/${type}`)
}

export default Icon
